const pastedNames = text => {
  const seen = new Set()
  const names = []
  String(text || '')
    .split(/[\n,]/)
    .forEach(part => {
      const name = part.trim()
      const key = name.toLowerCase()
      if (!key || seen.has(key)) return
      seen.add(key)
      names.push(name)
    })
  return names
}

/** Name contains filters the list. Paste reports exact names and does not hide the filter. */
export const groupsForAddPicker = (groups, contains, pasted) => {
  const rows = groups || []
  const names = pastedNames(pasted)
  const needle = String(contains || '')
    .trim()
    .toLowerCase()
  const matches = needle
    ? rows.filter(group =>
        String(group.name || '')
          .toLowerCase()
          .includes(needle),
      )
    : rows
  const wanted = new Set(names.map(name => name.toLowerCase()))
  const pastedMatches = names.length
    ? rows.filter(group =>
        wanted.has(
          String(group.name || '')
            .trim()
            .toLowerCase(),
        ),
      )
    : []
  const found = new Set(
    pastedMatches.map(group =>
      String(group.name || '')
        .trim()
        .toLowerCase(),
    ),
  )
  return {
    matches,
    pastedMatches,
    unmatched: names.filter(name => !found.has(name.toLowerCase())),
  }
}

export const groupsByVenue = groups => {
  const map = new Map()
  ;(groups || []).forEach(group => {
    ;(group.venues || []).forEach(venueId => {
      const key = String(venueId)
      if (!map.has(key)) map.set(key, [])
      map.get(key).push({ _id: group._id, name: group.name || 'Group' })
    })
  })
  return map
}

export const venuesForGroupFilter = (venues, groups, filter) => {
  if (!filter || filter === 'all') return venues || []
  const map = groupsByVenue(groups)
  if (filter === 'none') {
    return (venues || []).filter(venue => !map.has(String(venue._id)))
  }
  return (venues || []).filter(venue =>
    (map.get(String(venue._id)) || []).some(
      group => String(group._id) === String(filter),
    ),
  )
}
export const addToGroupsOutcome = ({ venueCount, added, failed }) => {
  const addedNames = (added || []).map(group => group.name).join(', ')
  const failedText = (failed || [])
    .map(group => `${group.name}: ${group.reason}`)
    .join(' ')
  if (!failed?.length) {
    return { ok: true, message: `Added ${venueCount} venues to ${addedNames}.` }
  }
  if (!added?.length) {
    return { ok: false, message: `Could not add those venues. ${failedText}` }
  }
  return {
    ok: false,
    message: `Added ${venueCount} venues to ${addedNames}. Could not add them to ${failedText}`,
  }
}
